var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    width: 30,
    height: 30,
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1272D",
    d: "M459.838 328.816c-29.899 83.693-109.867 143.592-203.836 143.592-93.97 0-173.938-59.899-203.837-143.592h407.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006A44",
    d: "M459.838 328.816H52.165c-8.13-22.755-12.571-47.267-12.571-72.815 0-30.994 6.531-60.457 18.265-87.112h396.287c11.741 26.653 18.262 56.121 18.262 87.112 0 25.548-4.44 50.06-12.57 72.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDB913",
    d: "M454.14 168.886H57.859C91.381 92.753 167.475 39.594 256.002 39.594c88.523 0 164.62 53.159 198.138 129.292z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/lt.a2bf0679f5e7ccd4dcbb5b3589de6631.svg";
export { ForwardRef as ReactComponent };